import { render, staticRenderFns } from "./MenuExterno.vue?vue&type=template&id=3dc2b085&scoped=true"
import script from "./MenuExterno.vue?vue&type=script&lang=js"
export * from "./MenuExterno.vue?vue&type=script&lang=js"
import style0 from "./MenuExterno.vue?vue&type=style&index=0&id=3dc2b085&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc2b085",
  null
  
)

/* custom blocks */
import block0 from "./MenuExterno.vue?vue&type=custom&index=0&blockType=br"
if (typeof block0 === 'function') block0(component)

export default component.exports